var hamburger = document.querySelector('.hamburger'),
    menu = document.querySelector('.navigation'),
    header = document.querySelector('.header'),
    body = document.body

//Toggle hamburger menu
function toggleMenu() {
    hamburger.classList.toggle('hamburger--open');
    menu.classList.toggle('navigation--open');
    header.classList.toggle('menu-open');
    body.classList.toggle('menu-open');
}

hamburger.addEventListener('click', toggleMenu);

//Add arrow if item has a submenu
document.querySelectorAll('.navigation > ul > li').forEach(function (element) {
    var childMenu = element.querySelector('.submenu, .categorymenu');

    if (childMenu) {
        var clickableArrow = document.createElement('span');

        clickableArrow.addEventListener('click', function (e) {
            e.preventDefault();
            element.classList.toggle('sub-open');
            childMenu.classList.toggle('sub-open');
            hamburger.classList.toggle('hamburger--sub-open');
        });
        element.insertBefore(clickableArrow, childMenu);
    }
});

//Show/hide navbar on scroll
var headerElement = document.querySelector('.header');
var c, currentScrollTop = 0;

export function menuScroll() {
    var a = window.scrollY;
    var headerHeight = headerElement.offsetHeight;

    currentScrollTop = a;

    if (window.scrollY <= 55) {
        headerElement.classList.remove('sticky');
        headerElement.classList.remove('navDown');
        headerElement.classList.remove('no-anim');
    } else if (window.scrollY >= 55 && window.scrollY <= 150) {
        headerElement.classList.add('no-anim');
    } else if (c < currentScrollTop && a > headerHeight) {
        headerElement.classList.add('sticky');
        headerElement.classList.add('navUp');
        headerElement.classList.remove('navDown');
    } else if (c > currentScrollTop && !(a <= headerHeight)) {
        headerElement.classList.add('navDown');
        headerElement.classList.remove('navUp');
        headerElement.classList.remove('no-anim');
    }
    c = currentScrollTop;
}


let languages = document.querySelectorAll('.language-selector .language');

document.querySelectorAll('.js-open-languages').forEach(function (element) {
    element.addEventListener('click', toggleLanguage);
    element.classList.toggle('is--open');
});

function toggleLanguage() {
    languages.forEach(function (language) {
        language.classList.toggle('language--open');
    });
}
